import React from 'react'
import './Button.scss'

function Button({icon, text, onClick, type='button', disabled, className=""}) {
  return (
    <button className={`custom-button text-white p-2 px-3 d-flex text-nowrap justify-content-between align-items-center mx-1 ${className}`} disabled={disabled} type={type} onClick={onClick} style={{
        backgroundColor: '#74613C',
    }}>
        {icon && <span className="mr-1">{icon}</span>} {text}
    </button>
  )
}

export default Button
